module.exports = __webpack_public_path__ + "static/ferie 2025-6c750d2d521d9f02ce360cd8a0aebcc5.png";